<div fxLayout="column">
    <h2 fxFlex="0 0 auto" mat-dialog-title class="center-align">Time Shift</h2>
    <mat-dialog-content fxFlex="auto" class="center-align">
        <!-- <mat-form-field>
            <input matInput [matDatepicker]="picker" placeholder="Choose a date" [formControl]="date">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field> -->
        <p-calendar [(ngModel)]="date" [showTime]="true" [inline]="true" [minDate]="minDateValue" [maxDate]="maxDateValue" hourFormat="24"></p-calendar>
    </mat-dialog-content>
    <div fxFlexFill>
        <span> </span>
    </div>

    <mat-dialog-actions fxFlex="0 0 auto" align="end">
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-button color="primary" [disabled]="!date" (click)="confirm()" [mat-dialog-close]="switchResult">Apply</button>
        <button mat-button color="alternate" [disabled]="!asOfDateMode" (click)="returnToLive()" [mat-dialog-close]="switchResult">Return to Live</button>
    </mat-dialog-actions>
</div>